import { PureComponent } from "react";
import { TokenView } from "../../../models/views/identity/TokenView";

export default class AuthenticatedComponent<P = {}, S = {}, SS = any> extends PureComponent<P, S, SS> {

    constructor(props: any) {
        super(props);
        let isAuthenticated: Boolean = false;
        if (localStorage.getItem("access_token") !== null) {

            let token: TokenView = JSON.parse(localStorage.getItem("access_token") as string);
            isAuthenticated = token.authenticated;
        }

        if (!isAuthenticated && !(window.location.href.includes("/Login") || window.location.href.includes("/Register"))) {
            window.location.href = "/Login";
        } else if (isAuthenticated && (window.location.href.includes("/Login") || window.location.href.includes("/Register")) && !window.location.href.includes("/RegisterReport"))
            window.location.href = "/Dashboard";
    }

    componentDidMount() {

    }
}

export class LoginCustomAuthenticatedComponenet<P = {}, S = {}, SS = any> extends PureComponent<P, S, SS> {

    constructor(props: any) {
        super(props);
        let isAuthenticated: Boolean = false;
        if (localStorage.getItem("access_token") !== null) {

            let token: TokenView = JSON.parse(localStorage.getItem("access_token") as string);
            isAuthenticated = token.authenticated;
        }

        if (isAuthenticated)
            window.location.href = "/Dashboard";
    }

    componentDidMount() {

    }
}